import { render, staticRenderFns } from "./jikaoSt.vue?vue&type=template&id=2a495dd2&scoped=true"
import script from "./jikaoSt.vue?vue&type=script&lang=js"
export * from "./jikaoSt.vue?vue&type=script&lang=js"
import style0 from "./jikaoSt.vue?vue&type=style&index=0&id=2a495dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a495dd2",
  null
  
)

export default component.exports